function getFocusableElements(container) {
    return Array.from(container.querySelectorAll([
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
    ].join(','))).filter(element => element.tabIndex >= 0 && Boolean(element.offsetParent || element.getClientRects().length));
}

function setSignupFormState(form, isSubmitting, hideWhenComplete = false) {
    if (!form) {
        return;
    }

    const submitButton = form.querySelector('[type="submit"]');
    const feedback = document.getElementById(form.dataset.newsletterSignupFeedback);

    form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

    if (submitButton) {
        submitButton.disabled = isSubmitting;
        submitButton.classList.toggle('is-loading', isSubmitting);
    }

    if (feedback && isSubmitting) {
        feedback.innerHTML = '';
    }

    if (!isSubmitting && hideWhenComplete) {
        form.hidden = true;
    }
}

function getNewsletterSignupForm(formOrId) {
    if (!formOrId) {
        return getBusyNewsletterSignupForm();
    }

    return typeof formOrId === 'string'
        ? document.getElementById(formOrId) || getBusyNewsletterSignupForm()
        : formOrId;
}

function getBusyNewsletterSignupForm() {
    const busyForms = Array.from(document.querySelectorAll('[data-newsletter-signup-form][aria-busy="true"]'));

    return busyForms.length === 1 ? busyForms[0] : null;
}

function focusSignupFeedback(form) {
    if (!form) {
        return;
    }

    const feedback = document.getElementById(form.dataset.newsletterSignupFeedback);
    if (feedback && feedback.textContent.trim()) {
        feedback.focus();
    }
}

function initNewsletterSignupBlock(block) {
    if (!block || block.dataset.newsletterSignupInitialized === 'true') {
        return;
    }

    const openButton = block.querySelector('[data-newsletter-signup-open]');
    const modal = block.querySelector('[data-newsletter-signup-modal]');
    const panel = block.querySelector('[data-newsletter-signup-panel]');
    const closeButtons = block.querySelectorAll('[data-newsletter-signup-close]');
    const form = block.querySelector('[data-newsletter-signup-form]');
    const modalTransitionDuration = 220;
    const reducedMotionQuery = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : { matches: false };
    let previousActiveElement = null;
    let closeTimeout = null;

    if (!openButton || !modal || !panel) {
        return;
    }

    block.dataset.newsletterSignupInitialized = 'true';

    if (form) {
        const feedback = block.querySelector('.newsletterSignupBlock-modalFeedback');
        if (feedback) {
            form.dataset.newsletterSignupFeedback = feedback.id;
        }
    }

    function openModal() {
        window.clearTimeout(closeTimeout);
        previousActiveElement = document.activeElement;
        modal.hidden = false;
        openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('newsletterSignupBlock-modalIsOpen');

        window.requestAnimationFrame(() => {
            modal.classList.add('is-open');

            const firstFocusableElement = getFocusableElements(panel)[0];
            (firstFocusableElement || panel).focus();
        });
    }

    function closeModal() {
        window.clearTimeout(closeTimeout);
        modal.classList.remove('is-open');
        openButton.setAttribute('aria-expanded', 'false');
        const closeDelay = reducedMotionQuery.matches ? 0 : modalTransitionDuration;

        closeTimeout = window.setTimeout(() => {
            modal.hidden = true;
            document.body.classList.remove('newsletterSignupBlock-modalIsOpen');

            if (form) {
                setSignupFormState(form, false);
                form.hidden = false;
                form.reset();
                const feedback = document.getElementById(form.dataset.newsletterSignupFeedback);
                if (feedback) {
                    feedback.innerHTML = '';
                }
            }

            if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
                previousActiveElement.focus();
            }
        }, closeDelay);
    }

    function trapFocus(event) {
        if (event.key !== 'Tab') {
            return;
        }

        const focusableElements = getFocusableElements(panel);

        if (!focusableElements.length) {
            event.preventDefault();
            panel.focus();
            return;
        }

        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
        }
    }

    openButton.addEventListener('click', openModal);

    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', event => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            closeModal();
            return;
        }

        trapFocus(event);
    });
}

function initNewsletterSignupBlocks() {
    document.querySelectorAll('[data-newsletter-signup]').forEach(initNewsletterSignupBlock);
}

function scheduleNewsletterSignupInit() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNewsletterSignupBlocks, { once: true });
        return;
    }

    initNewsletterSignupBlocks();
}

function onNewsletterSignupFormSubmit(form) {
    setSignupFormState(getNewsletterSignupForm(form), true);
}

function onNewsletterSignupSubmitFail(formId) {
    const form = getNewsletterSignupForm(formId);
    const feedback = form
        ? document.getElementById(form.dataset.newsletterSignupFeedback)
        : null;

    if (feedback) {
        feedback.innerHTML = 'Noe gikk dessverre galt. Vennligst prøv igjen senere.';
    }

    setSignupFormState(form, false, false);
    focusSignupFeedback(form);
}

function onNewsletterSignupSubmitSuccess(formId) {
    const form = getNewsletterSignupForm(formId);

    setSignupFormState(form, false, true);
    focusSignupFeedback(form);
}

scheduleNewsletterSignupInit();
window.addEventListener('statnett:apps-updated', initNewsletterSignupBlocks);

window.onNewsletterSignupFormSubmit = onNewsletterSignupFormSubmit;
window.onNewsletterSignupSubmitFail = onNewsletterSignupSubmitFail;
window.onNewsletterSignupSubmitSuccess = onNewsletterSignupSubmitSuccess;
